export const FilterValue = {
	displayAll: "display-all",
};
